import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n/i18n"; // Import i18n configuration

const injectFonts = () => {
  const fonts = [
    "https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700&display=swap",
    "https://fonts.googleapis.com/css2?family=Mukta:wght@300;400;500;600;700&display=swap",
    "https://fonts.googleapis.com/css2?family=Itim&display=swap",
    "https://fonts.googleapis.com/css2?family=Allura&family=Dancing+Script:wght@400;500;600;700&family=Great+Vibes&family=Pacifico&display=swap",
  ];

  fonts.forEach((href) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    document.head.appendChild(link);
  });
};

// Call it before React renders
injectFonts();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
